import { OrderedMap } from "immutable";

export interface IOption<T = string> {
    value: T;
    label: string;
    selected?: boolean;
    key?: string;
    /**
     * Options with the same group value are grouped together. Between groups a separator is added.
     */
    group?: string;
    withSeparator?: boolean;
}

export interface IOptionIconMenu extends IOption {
    id: string;
    leftIcon?: JSX.Element;
}

export const ALL_OPTION_GROUP = "__all_group";

export enum SortOrder {
    ASC = "asc",
    DESC = "desc",
}

export enum ISortOrderGrid {
    Ascending = "ASCENDING",
    Descending = "DESCENDING",
}

export type ISortOrder = "asc" | "desc";

export interface ISort {
    sort: string;
    sortOrder: ISortOrder;
}

export interface IBaseParams {
    filters?: OrderedMap<string, any>;
    search?: string;
    sort?: string;
    sortOrder?: ISortOrder;
    limit?: number;
}

export enum OrderByDirection {
    Asc = "ASC",
    Desc = "DESC",
}

export interface TargetMousePosition {
    x: number;
    y: number;
}

export interface IImageCellDimensions {
    width?: number;
    height?: number;
}

export enum BEItemValidationStatus {
    PASS = "PASS",
    PARTIAL = "PARTIAL",
    FAIL = "FAIL",
}

export enum ItemsInStatusList {
    Validated = "validated",
    Errored = "errored",
    Warned = "warned",
}

export enum ItemViewType {
    Panel = "panel",
    Tile = "tile",
    LargeTile = "largeTile",
    Card = "card",
    List = "list",
}

export enum ItemCellSize {
    Card = "card",
    Tile = "tile",
    LargeTile = "large-tile",
    List = "list",
    Big = "big",
    Collection = "collection",
}

export enum SearchSettings {
    SearchType = "search-type",
}

export interface IOrderRecapPayload {
    options: string[];
    includeInPdf: boolean;
}
